import { InformationBarType } from "./information-bar.type";

export class InformationBar {
    idBloc: string;
    idInformationBar: string;
    message: string;
    autoClose: boolean;
    closeEnable: boolean;
    type: InformationBarType;
    fade: boolean;
    messageButton: string;
    buttonClick: () => void;
    iconName?: string; // Optional Heroicon name (e.g., 'heroicons_solid:exclamation-triangle')
    iconColor?: string; // Optional icon color class (e.g., 'text-yellow-600')
    remove?: boolean;

    constructor(init?:Partial<InformationBar>) {
        Object.assign(this, init);
    }
}